export default __webpack_public_path__ + "static/media/logo_newtral.26d6c669.svg";